// Utils
import { assert } from '../../others';
import { isObject } from '../checks';
/**
 * Gets shallow arraysDifference of two objects, grouping keys into how they have changed
 *
 * @template T extends object
 * @param {T} base
 * @param {T} target
 *
 * @return {DiffResult<T>}
 */
export var shallowDifferences = function (base, target) {
    assert(isObject(base), "Argument 'a' expecting a non-array or null object " + base.toString() + " given");
    assert(isObject(target), "Argument 'b' expecting a non-array or null object " + target.toString() + " given");
    var result = {
        unchanged: [],
        updated: [],
        deleted: [],
        added: [],
    };
    // @todo: potentially change this to a map to optimise comparison
    Object.keys(base).forEach(function (keyOfA) {
        // eslint-disable-next-line no-prototype-builtins
        if (!target.hasOwnProperty(keyOfA)) {
            result.deleted.push(keyOfA);
        }
        else if (target[keyOfA] !== base[keyOfA]) {
            result.updated.push(keyOfA);
        }
        else {
            result.unchanged.push(keyOfA);
        }
    });
    Object.keys(target).forEach(function (keyOfB) {
        // eslint-disable-next-line no-prototype-builtins
        if (!base.hasOwnProperty(keyOfB)) {
            result.added.push(keyOfB);
        }
    });
    return result;
};
//# sourceMappingURL=shallowDifferences.js.map